import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

const DVCDashboard = lazy(() => import("./DVCDashboard"));

const DVCDASH_ROUTES: RouteObject[] = [
  {
    path: "/private/dvc-dashboard",
    element: React.createElement(DVCDashboard),
  },
];

export default DVCDASH_ROUTES;
